import { useState } from "react";
import { authService } from "../services/authService";
import { C, Btn, Input } from "./ui";

export function LoginScreenEmail({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [nombreCampo, setNombreCampo] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleAuth = async () => {
    if (!email || !password) {
      setError("Completá email y contraseña");
      return;
    }

    if (isSignup && password !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    if (isSignup && password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setLoading(true);
    setError("");

    try {
      if (isSignup) {
        const result = await authService.signup(email, password, nombreCampo);
        onLogin(result.usuario);
      } else {
        const result = await authService.login(email, password);
        onLogin(result.usuario);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${C.pasto} 0%, ${C.tierra} 100%)`,
      }}
    >
      <div
        style={{
          background: C.white,
          borderRadius: 16,
          padding: 32,
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            fontFamily: "serif",
            fontSize: 28,
            fontWeight: 600,
            color: C.tierra,
            marginBottom: 8,
            textAlign: "center",
          }}
        >
          Campo<span style={{ color: C.pasto, fontStyle: "italic" }}>IA</span>
        </div>
        <div
          style={{
            fontSize: 13,
            color: C.muted,
            marginBottom: 24,
            textAlign: "center",
          }}
        >
          Gestión de rodeo y campos
        </div>

        <Input
          label="Email"
          value={email}
          onChange={setEmail}
          type="email"
          placeholder="tu@email.com"
        />
        <div style={{ marginBottom: 14, position: "relative" }}>
          <div style={{ fontSize: 12, fontFamily: "monospace", textTransform: "uppercase", letterSpacing: "0.08em", color: C.muted, marginBottom: 6, fontWeight: 500 }}>Contraseña</div>
          <div style={{ position: "relative" }}>
            <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              style={{ width: "100%", padding: "10px 12px 10px 12px", border: `1.5px solid ${C.arenaDark}`, borderRadius: 8,
                fontFamily: "sans-serif", fontSize: 14, background: C.arena, color: C.texto, outline: "none", boxSizing: "border-box" }} />
            <button type="button" onClick={() => setShowPassword(!showPassword)} style={{
              position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none",
              cursor: "pointer", fontSize: 16, color: C.muted, padding: 4
            }}>
              {showPassword ? "👁️" : "👁️‍🗨️"}
            </button>
          </div>
        </div>

        {isSignup && (
          <>
            <div style={{ marginBottom: 14, position: "relative" }}>
              <div style={{ fontSize: 12, fontFamily: "monospace", textTransform: "uppercase", letterSpacing: "0.08em", color: C.muted, marginBottom: 6, fontWeight: 500 }}>Confirmar contraseña</div>
              <div style={{ position: "relative" }}>
                <input type={showConfirm ? "text" : "password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="••••••••"
                  style={{ width: "100%", padding: "10px 12px 10px 12px", border: `1.5px solid ${C.arenaDark}`, borderRadius: 8,
                    fontFamily: "sans-serif", fontSize: 14, background: C.arena, color: C.texto, outline: "none", boxSizing: "border-box" }} />
                <button type="button" onClick={() => setShowConfirm(!showConfirm)} style={{
                  position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none",
                  cursor: "pointer", fontSize: 16, color: C.muted, padding: 4
                }}>
                  {showConfirm ? "👁️" : "👁️‍🗨️"}
                </button>
              </div>
            </div>
            <Input
              label="Nombre del campo"
              value={nombreCampo}
              onChange={setNombreCampo}
              placeholder="Ej: El Paraíso"
            />
          </>
        )}

        {error && (
          <div
            style={{
              background: "#FAE8E8",
              color: C.danger,
              padding: "10px 12px",
              borderRadius: 8,
              fontSize: 12,
              marginBottom: 14,
              textAlign: "center",
            }}
          >
            {error}
          </div>
        )}

        <Btn
          variant="primary"
          onClick={handleAuth}
          disabled={loading || !email || !password}
          style={{ width: "100%", marginBottom: 10 }}
        >
          {loading ? "Cargando..." : isSignup ? "Crear cuenta" : "Iniciar sesión"}
        </Btn>

        <button
          onClick={() => {
            setIsSignup(!isSignup);
            setError("");
            setConfirmPassword("");
            setNombreCampo("");
          }}
          style={{
            width: "100%",
            background: "none",
            border: "none",
            color: C.pasto,
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          {isSignup ? "¿Ya tienes cuenta? Inicia sesión" : "¿Nuevo? Crear cuenta"}
        </button>
      </div>
    </div>
  );
}

export function LogoutButton({ user, onLogout }) {
  return (
    <button
      onClick={() => {
        authService.logout();
        onLogout();
      }}
      style={{
        background: "none",
        border: "none",
        color: C.muted,
        cursor: "pointer",
        fontSize: 12,
        fontFamily: "monospace",
      }}
    >
      {user?.email || "Usuario"} · Salir
    </button>
  );
}
